// reducers.js
import { LOGIN, LOGOUT } from "./action";

const initialState = {
  isLoggedIn: localStorage.getItem("token") ? true : false,
  username: localStorage.getItem("username") || "",
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN:
      console.log(`用户 ${action.payload.username} 已成功登录`);
      return { ...state, isLoggedIn: true, username: action.payload.username };
    case LOGOUT:
      console.log(`用户 ${state.username} 已成功登出`);
      return { ...state, isLoggedIn: false, username: "" };
    default:
      return state;
  }
};

export default authReducer;
